module.exports = __webpack_public_path__ + "img/ticket.eb5ed07.png";